import React, { useEffect, useState } from "react";
import { Inline } from "@nib/layout";
import PropTypes from "prop-types";
import { TickSystemIcon, UploadSystemIcon } from "@nib/icons";
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton } from "react-share";
import useWindowDimensions from "../../utils/breakpoints";
import { SecondaryButton } from "@nib-components/button";
import styled from "styled-components";
import colors from "@nib-components/colors";
import Copy from "@nib-components/copy";
import Tooltip from "@nib/tooltip";

import Facebook from "./assets/Facebook.svg";
import Link from "./assets/Link.svg";
import LinkedIn from "./assets/LinkedIn.svg";
import Twitter from "./assets/Twitter.svg";
import breakpoint from "styled-components-breakpoint";
const StyledSecondaryButton = styled(SecondaryButton)`
  background-color: inherit;
`;

const SvgImg = styled.img`
  width: 38px;
  height: 38px;

  ${breakpoint("md")`
    width: 32px;
    height: 32px;
  `};
`;

/** Social Share component
 *  Modern Layout is the navigator.share version on mobiles. By default, this is true but we can override
 *  to false to allow for the icons to show rather than modernised versions.
 * */
const SocialShare = ({ title, modernLayout = true }) => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const { isMobile } = useWindowDimensions();
  const [hasShared, setHasShared] = useState(false);
  const [copiedText, setCopiedText] = useState(false);

  return (
    <>
      {isMobile && modernLayout && navigator.share ? (
        <StyledSecondaryButton
          icon={hasShared ? TickSystemIcon : UploadSystemIcon}
          onClick={() => {
            navigator
              .share({
                title,
                url,
              })
              .then(() => {
                setHasShared(true);
              })
              .catch();
          }}
        >
          Share
        </StyledSecondaryButton>
      ) : (
        <Inline space={{ xs: 3, md: 2 }} verticalAlign="center">
          <Copy color={colors.dopey}>Share via </Copy>
          <FacebookShareButton url={url}>
            <SvgImg src={Facebook} alt="Facebook Logo" />
          </FacebookShareButton>
          <TwitterShareButton url={url}>
            <SvgImg src={Twitter} alt="Twitter logo" />
          </TwitterShareButton>
          <LinkedinShareButton url={url}>
            <SvgImg src={LinkedIn} alt="LinkedIn logo" />
          </LinkedinShareButton>
          <Tooltip
            mode="dark"
            placement="top"
            tooltipContents={<p>{copiedText ? "Copied" : "Copy link"}</p>}
          >
            {({ triggerProps }) => (
              <Inline space={4}>
                <div aria-label="Help" {...triggerProps}>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(url);
                      setCopiedText(true);
                      setTimeout(() => {
                        setCopiedText(false);
                      }, 2000);
                    }}
                  >
                    <SvgImg src={Link} alt="Copy Button" />
                  </button>
                </div>
              </Inline>
            )}
          </Tooltip>
        </Inline>
      )}
    </>
  );
};

SocialShare.propTypes = {
  title: PropTypes.string.isRequired,
  modernLayout: PropTypes.bool,
};

export default SocialShare;
